// @ts-nocheck
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { linkStyles } from "@store/Themes/common/mixins/link";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    eventLink?: string;
    linkLabel: string;
    lightText?: boolean;
    extendedStyles?: EventLinkStyles;
}

export interface EventLinkStyles {
    link?: LinkPresentationProps;
}

export const eventLinkStyles: EventLinkStyles = {
    link: {
        typographyProps: {
            css: css`
                font-weight: ${x => x.theme.design.typography.weight.semibold};
            `,
        },
        css: css`
            margin-top: ${pxToRem(15)};
        `,
    },
};

const EventLink = ({ eventLink, linkLabel, lightText, extendedStyles }: Props) => {
    const styles = useMergeProps(eventLinkStyles, extendedStyles);

    if (!eventLink) {
        return null;
    }

    const linkStyle = css`
        ${styles.link?.css}
        ${lightText
            ? linkStyles("white", "white", true, false)
            : linkStyles("primary.main", "primary.dark", true, false)}
    `;

    return (
        <Link href={eventLink} {...styles.link} css={linkStyle}>
            {linkLabel}
        </Link>
    );
};

export default EventLink;
